import axios from "axios";
import * as firebase from "firebase";
import * as R from "ramda";

axios.interceptors.response.use(
  (response) => {
    console.log("received", response.status);
    // Edit response config
    if (response.status === 402) {
      document.location = `${document.location.origin}/#/offers`;
    }
    return response;
  },
  (error) => {
    if (error.response.status === 402) {
      document.location = `${document.location.origin}/#/offers`;
    } else {
      return Promise.reject(error);
    }
  }
);

const getUser = () => {
  return window.user;
};

export const getToken = async () => {
  const token = await firebase.auth().currentUser.getIdToken(false);
  window.token = token;
  return token;
};

export const createCheckoutSession = async (offer) => {
  return (
    await axios.post(
      `${process.env.VUE_APP_CALYPSO}/create-checkout-session`,
      {
        offer,
      },
      {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      }
    )
  ).data;
};

export const me = async () => {
  return (
    await axios.get(`${process.env.VUE_APP_CALYPSO}/stats`, {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    })
  ).data;
};
export const link = async (target, source) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/op/task2task`,
    {
      taskId: target,
      dependsOnId: source,
    },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};
export const unlink = async (target, source) => {
  await axios.delete(`${process.env.VUE_APP_CALYPSO}/op/task2task`, {
    data: {
      taskId: target,
      dependsOnId: source,
    },
    headers: {
      Authorization: `Bearer ${await getToken()}`,
    },
  });
};

export const updateTask = async (task) => {
  await axios.put(
    `${process.env.VUE_APP_CALYPSO}/task/${task.id}`,
    {
      ...R.pick(
        [
          "id",
          "title",
          "description",
          "businessValue",
          "board_id",
          "done",
          "paused",
        ],
        task
      ),
    },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const deleteTask = async (taskId) => {
  await axios.delete(`${process.env.VUE_APP_CALYPSO}/task/${taskId}`, {
    headers: {
      Authorization: `Bearer ${await getToken()}`,
    },
  });
};

export const postLayout = async (boardId, nodePositions) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/op/layout`,
    {
      boardId,
      nodePositions,
    },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const undoAction = async (actionId) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/undo`,
    { id: actionId },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};
export const listActions = async (boardId) => {
  const actionsLogResponse = await axios.get(
    `${process.env.VUE_APP_CALYPSO}/board/${boardId}/log/0`,
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
  const data = actionsLogResponse.data;
  localStorage.setItem(`${boardId}_actions`, JSON.stringify(data));
  return data;
};

export const getBoardData = async (boardId) => {
  const response = await axios.get(
    `${process.env.VUE_APP_CALYPSO}/board/${boardId}`,
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
  const data = response.data;
  return data;
};

export const listTasks = async (boardId) => {
  const strTasks = localStorage.getItem(`${boardId}_tasks`);
  let { tasks, deps, lastUpdate } = JSON.parse(strTasks) || {};
  if (!tasks) {
    const tasksResponse = await axios.get(
      `${process.env.VUE_APP_CALYPSO}/list-task-board/${boardId}`,
      {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      }
    );
    tasks = tasksResponse.data.tasks;
    deps = tasksResponse.data.deps;
    lastUpdate = tasksResponse.data.lastUpdate;
  }
  // get action since lastupdate here --->

  // <---- get action since lastupdate here
  // lastUpdate = "0";
  const opsResponse = await axios.get(
    `${process.env.VUE_APP_CALYPSO}/ops/${boardId}/${lastUpdate}`,
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
  console.log("ops", opsResponse.data);
  const ops = opsResponse.data.ops;
  for (let oIdx = 0; oIdx < ops.length; oIdx++) {
    const op = ops[oIdx];
    if (op.o_op === "taskUpdate") {
      console.log("tupdate");
      let t = tasks.find((t) => t.id === op.t_id);
      if (t) {
        t.title = op.t_title;
        t.description = op.t_description;
        t.business_value = op.t_business_value;
        t.updated = op.t_updated;
        t.done = op.t_done;
        t.paused = op.t_paused;
      } else {
        t = {
          id: op.o_task_id,
          board_id: op.t_board_id,
          title: op.t_title,
          description: op.t_description,
          business_value: op.t_business_value,
          updated: op.t_updated,
          created: op.t_created,
          done: op.t_done,
          paused: op.t_paused,
        };
        tasks.unshift(t);
      }
    }
    if (op.o_op === "taskDelete") {
      console.log("tdelete", op);
      tasks = tasks.filter((t) => t.id !== op.o_task_id);
    }
    if (op.o_op === "depUpdate") {
      console.log("dupdate");
      deps.push({
        task_id: op.o_task_id,
        depends_on_id: op.o_depends_on_id,
      });
    }
    if (op.o_op === "depDelete") {
      console.log("ddelete");
      deps = deps.filter(
        (d) =>
          !(
            d.task_id === op.o_task_id && d.depends_on_id === op.o_depends_on_id
          )
      );
    }
  }
  lastUpdate = opsResponse.data.lastUpdate;
  localStorage.setItem(
    `${boardId}_tasks`,
    JSON.stringify({ tasks, deps, lastUpdate })
  );
  return { tasks, deps, lastUpdate };
};

export const createNewTask = async (boardId, task) => {
  const response = await axios.post(
    `${process.env.VUE_APP_CALYPSO}/task`,
    { ...task, boardId },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
  return response.data;
};

export const createBoard = async (newBoardTitle) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/board`,
    { title: newBoardTitle, description: "" },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const updateBoard = async (board) => {
  await axios.put(
    `${process.env.VUE_APP_CALYPSO}/board/${board.id}`,
    { title: board.title, description: "" },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const deleteBoard = async (board) => {
  await axios.delete(`${process.env.VUE_APP_CALYPSO}/board/${board.id}`, {
    headers: {
      Authorization: `Bearer ${await getToken()}`,
    },
  });
};

export const leaveBoard = async (board) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/kick/${board.id}/${getUser().email}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const getBoards = async () => {
  const response = await axios.get(`${process.env.VUE_APP_CALYPSO}/boards`, {
    headers: {
      Authorization: `Bearer ${await getToken()}`,
    },
  });
  return response.data;
};

export const reorderBoards = async (boardIds) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/reorderBoards/${getUser().email}`,
    { boardIds },
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const invite = async (boardId, email, role) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/invite/${boardId}/${email}/${role}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const kick = async (boardId, email) => {
  await axios.post(
    `${process.env.VUE_APP_CALYPSO}/kick/${boardId}/${email}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
};

export const listSharing = async (boardId) => {
  const boardsResult = await axios.get(
    `${process.env.VUE_APP_CALYPSO}/sharing/${boardId}`,
    {
      headers: {
        Authorization: `Bearer ${await getToken()}`,
      },
    }
  );
  return boardsResult.data;
};
